import { Button, Container, Divider, Text } from '@doist/marketist'

import { useTranslation } from 'next-i18next'
import { appendUTM } from 'services'

import css from './IntegrationAppPremiumCTA.module.css'

export function IntegrationAppPremiumCTA() {
    const { t } = useTranslation('integrations')
    const upgradeLink = appendUTM('/billing', { utm_campaign: 'integrations' })

    return (
        <Container className={css.ctaContainer}>
            <Divider className={css.divider} separator />

            <div className={css.copy}>
                <Text tag="h4" size="major-base" className={css.header}>
                    {t('premium.header')}
                </Text>
                <Text size="body-lg" className={css.body}>
                    {t('premium.subheader')}
                </Text>
                <Button href={upgradeLink} target="_blank">
                    {t('premium.cta')}
                </Button>
            </div>
        </Container>
    )
}
